import { lazy, Suspense } from 'react'

export const RoutesComponents = (props) => {

    //console.log('nameComponent', `./components/${props.route}/${props.component}`)

    const ComponentRender = lazy(() => import(`./components/${props.route}/${props.component}`))

    return (
        <Suspense fallback={<div>Cargando Component...</div>}>
            <ComponentRender />
        </Suspense>
    )
}